import {useCallback} from 'react';

import {useStateSelector, useNavigateRef} from '~ui/hooks';

import {getSubPageLink, isObject} from '~ui/utils';
import {selectUserSettingByKey} from '~ui/store/slices/user-settings';

type DialogParams = {
    type?: string;
    clusterSlug?: string;
};

interface CreatePageParams {
    dialog?: boolean | DialogParams;
    event: MouseEvent | React.MouseEvent;
}

export const useCreatePage = () => {
    const navigateRef = useNavigateRef();
    const isFastCreate = useStateSelector(selectUserSettingByKey('fast_create'));
    const navigate = navigateRef.current;

    return useCallback(
        async ({dialog, event}: CreatePageParams) => {
            const params = isObject(dialog) ? dialog : {};

            if (!isFastCreate || (isFastCreate && event.shiftKey)) {
                navigate(getSubPageLink('.create', params));
            } else {
                navigate(
                    getSubPageLink('.create', {
                        ...params,
                        draft: '1',
                        retpath: window.location.pathname,
                    }),
                );
            }
        },
        [navigate, isFastCreate],
    );
};
